<template>
  <v-card flat tile height="100%">
    <v-layout fill-height :column="$vuetify.breakpoint.smAndDown">
      <v-flex xs7 class="pa-0">
        <v-card flat tile color="white" min-height="100%" class="pa-4">
          <h2 class="display-1 secondary--text">
            {{ listing.title }}
          </h2>
          <p class="subheading">
            {{ listing.description }}
          </p>
          <router-link
            v-for="(shield, key) in SHIELDS"
            :key="key"
            :to="{ name: 'About', hash: `#${key}` }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-img
                  v-if="
                    listing.shields && listing.shields.includes(shield.title)
                  "
                  :src="require(`../assets/${shield.imgsrc}`)"
                  class="shield-img d-inline-block"
                  v-on="on"
                />
              </template>
              <span>{{ shield.title }} (Click for more information)</span>
            </v-tooltip>
          </router-link>
        </v-card>
      </v-flex>
      <v-flex xs5 class="pa-0">
        <v-card flat tile color="grey lighten-3" min-height="100%" class="pa-4">
          <h6 class="title secondary--text">
            Contact
          </h6>
          <p v-if="listing.address" class=".body-1 primary--text overflow-wrap">
            Address: {{ listing.address }}
          </p>
          <p v-if="listing.phone" class=".body-1 primary--text overflow-wrap">
            Tel: {{ listing.phone }}
          </p>
          <p
            v-if="listing.dsnphone"
            class=".body-1 primary--text overflow-wrap"
          >
            Military DSN Tel: {{ listing.dsnphone }}
          </p>
          <p v-if="listing.email" class=".body-1 primary--text overflow-wrap">
            Email: {{ listing.email }}
          </p>
          <a
            v-if="listing.website && !kioskMode"
            :href="listing.website"
            class=".body-1 primary--text overflow-wrap"
          >
            Website: {{ listing.website }}
          </a>
          <p
            v-else-if="listing.website"
            class=".body-1 primary--text overflow-wrap"
          >
            Website: {{ listing.website }}
          </p>
          <div v-if="listing.website && kioskMode" style="text-align:center">
            <div style="width:200px; margin:auto">
              <qr-code :text="listing.website" :size="200" />
            </div>
            Scan the QR code with your smart device's camera app for more
            information
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { SHIELDS } from "../constants";
import QrCode from "vue-qrcode-component";
import { mapState } from "vuex";

export default {
  components: {
    QrCode
  },
  props: {
    // TODO:
    // eslint-disable-next-line vue/require-default-prop
    listing: Object
  },
  computed: {
    ...mapState({ kioskMode: state => state.kioskMode }),
    SHIELDS() {
      return SHIELDS;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

.shield-img {
  width: 20%;
  max-width: 80px;
}

.overflow-wrap {
  overflow-wrap: break-word;
}
</style>
